import {
    CartWorkflowStepValidationResults,
    DefaultCartWorkflowStepValidationResults
} from '../CartWorkflow.types';
import { ICartProps } from '../../../contexts/CartContext/CartContext.types';
import { PlanType } from 'types/Plan';

const useValidateCartPage = (cart: ICartProps): CartWorkflowStepValidationResults => {
    const results = DefaultCartWorkflowStepValidationResults();

    if (cart.accessories.length === 0 && cart.lineItems.length === 0) {
        results.messages.push('Please add an item to the cart before attempting to checkout.');
        results.isValid = false;
        return results;
    }

    const hasLinesWithPlans = cart.lineItems.every((x) => x.planSelection);
    if (!hasLinesWithPlans) {
        results.messages.push('Please add a plan to the cart before attempting to checkout.');
        results.isValid = false;
        return results;
    }

    const hasLinesWithDevices = cart.lineItems.every(
        (x) => x.planSelection?.plan?.planType === PlanType.HomeInternet || (x.device ?? x.byod)
    );
    if (!hasLinesWithDevices) {
        results.messages.push(
            'Each phone line must have a device associated with it before attempting to checkout.'
        );
        results.isValid = false;
        return results;
    }

    const nonInternetLines = cart.lineItems.filter(
        (x) => x.planSelection?.plan?.planType !== PlanType.HomeInternet
    );

    if (nonInternetLines.length !== 0) {
        const primaryLine = nonInternetLines.filter((x) => x.isPrimaryLine);

        if (primaryLine.length === 1) return results;

        results.isValid = false;
        results.messages.push('Please select an Account Holder line before proceeding.');
        return results;
    }

    return results;
};

export default useValidateCartPage;
